import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-quill-pen-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                po文学指南
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注于po文学创作技巧与行业趋势的综合性知识平台，帮助每一位创作者写出打动人心的作品。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/rumen" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  入门指南
                </Link>
              </li>
              <li>
                <Link to="/category/jiqiao" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  创作技巧
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-100 mb-4 text-sm">关注我们</h4>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              持续更新po文学最新资讯与深度内容，欢迎关注我们的社交媒体账号。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-background-300 hover:text-primary-400 hover:bg-foreground-700 transition-colors" aria-label="小红书" rel="nofollow">
                <i className="ri-booklet-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 po文学指南. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}